import script from "./AlbumBox.vue?vue&type=script&setup=true&lang=js"
export * from "./AlbumBox.vue?vue&type=script&setup=true&lang=js"

import "./AlbumBox.vue?vue&type=style&index=0&id=6a381aa8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a381aa8"]])

export default __exports__